function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 50,
  height: 50,
  fill: "#D9D9D9"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_4166_7058)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.7821 43.75C12.8498 43.75 12.0557 43.4222 11.3998 42.7667C10.7443 42.1108 10.4165 41.3167 10.4165 40.3844V22.1156C10.4165 21.1833 10.7443 20.3892 11.3998 19.7333C12.0557 19.0778 12.8498 18.75 13.7821 18.75H16.6665V14.5833C16.6665 12.2622 17.4752 10.2931 19.0925 8.67604C20.7096 7.05868 22.6787 6.25 24.9998 6.25C27.321 6.25 29.2901 7.05868 30.9071 8.67604C32.5245 10.2931 33.3332 12.2622 33.3332 14.5833V18.75H36.2175C37.1498 18.75 37.9439 19.0778 38.5998 19.7333C39.2554 20.3892 39.5832 21.1833 39.5832 22.1156V40.3844C39.5832 41.3167 39.2554 42.1108 38.5998 42.7667C37.9439 43.4222 37.1498 43.75 36.2175 43.75H13.7821ZM13.7821 41.6667H36.2175C36.5915 41.6667 36.8988 41.5465 37.1394 41.3063C37.3797 41.0656 37.4998 40.7583 37.4998 40.3844V22.1156C37.4998 21.7417 37.3797 21.4344 37.1394 21.1937C36.8988 20.9535 36.5915 20.8333 36.2175 20.8333H13.7821C13.4082 20.8333 13.1009 20.9535 12.8603 21.1937C12.62 21.4344 12.4998 21.7417 12.4998 22.1156V40.3844C12.4998 40.7583 12.62 41.0656 12.8603 41.3063C13.1009 41.5465 13.4082 41.6667 13.7821 41.6667ZM24.9998 34.375C25.8787 34.375 26.6191 34.0738 27.2212 33.4714C27.8236 32.8693 28.1248 32.1288 28.1248 31.25C28.1248 30.3712 27.8236 29.6307 27.2212 29.0286C26.6191 28.4262 25.8787 28.125 24.9998 28.125C24.121 28.125 23.3806 28.4262 22.7785 29.0286C22.1761 29.6307 21.8748 30.3712 21.8748 31.25C21.8748 32.1288 22.1761 32.8693 22.7785 33.4714C23.3806 34.0738 24.121 34.375 24.9998 34.375ZM18.7498 18.75H31.2498V14.5833C31.2498 12.8472 30.6422 11.3715 29.4269 10.1562C28.2116 8.94097 26.7359 8.33333 24.9998 8.33333C23.2637 8.33333 21.788 8.94097 20.5728 10.1562C19.3575 11.3715 18.7498 12.8472 18.7498 14.5833V18.75Z",
  fill: "#1C1B1F"
}));

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4166_7058",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _ref2), _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.3e798bc45e0d44cba412b1894002a3a7.svg";
export { ForwardRef as ReactComponent };